import React, { useState } from "react";
import { ScaleLoader } from "react-spinners";
import { Modal } from "react-bootstrap";
import { AxiosPost } from "../../../../../context/UserContext";
import { pushNotify } from "../../../../../services/NotifyService";
import { useEffect } from "react";
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import Button from '@inovua/reactdatagrid-community/packages/Button';
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter'
import DateFilter from '@inovua/reactdatagrid-community/DateFilter'
import moment from "moment";
import CreatableSelect from 'react-select/creatable';
import * as XLSX from 'xlsx';

function GeneratorLogsTable() {
    const [isLoading, setIsLoading] = useState(false);
    const [deleteModal, setDeleteModal] = useState({ show: false, id: null });
    const [generatorLogs, setGeneratorLogs] = useState([]);
    const gridStyle = { height: 'calc(100vh - 16.5rem)', marginTop: 10 };
    const [gridRef, setGridRef] = useState(null)
    const initialFormData = { vendor_name: '', generator_type: '', shoot_date: moment().format("YYYY-MM-DD"), start_time: '', end_time: '', start_time2: '', end_time2: '', start_time3: '', end_time3: '', no_of_hours: 0, remarks: '' }
    const [formData, setFormData] = useState([initialFormData])
    window.moment = moment
    const [customsl, setCustomSl] = useState('0')
    const [isLoading2, setIsLoading2] = useState(false)
    const [generatorOptions, setGeneratorOptions] = useState([])
    const [uploadData, setUploadData] = useState(null)

    const filterValue = [
        { name: "num_row", operator: 'eq', type: 'number', value: null },
        { name: 'generator_type', operator: 'startsWith', type: 'string', value: '' },
        { name: 'vendor_name', operator: 'startsWith', type: 'string', value: '' },
        { name: 'shoot_date', operator: 'after', type: 'date', value: '' },
        { name: 'start_time', operator: 'startsWith', type: 'string', value: '' },
        { name: 'end_time', operator: 'startsWith', type: 'string', value: '' },
        { name: 'start_time2', operator: 'startsWith', type: 'string', value: '' },
        { name: 'end_time2', operator: 'startsWith', type: 'string', value: '' },
        { name: 'start_time3', operator: 'startsWith', type: 'string', value: '' },
        { name: 'end_time3', operator: 'startsWith', type: 'string', value: '' },
        { name: 'no_of_hours', operator: 'startsWith', type: 'string', value: '' },
        { name: 'remarks', operator: 'startsWith', type: 'string', value: '' },
    ];

    const columns = [
        { name: 'num_row', header: 'sl', type: 'number', editable: false },
        { name: 'generator_type', header: 'Generator Type', minWidth: 150 },
        { name: 'vendor_name', header: 'Vendor Name', minWidth: 150 },
        {
            name: 'shoot_date', defaultFlex: 2, header: 'Shoot Date',
            dateFormat: 'YYYY-MM-DD',
            filterEditor: DateFilter, minWidth: 150
        },
        { name: 'start_time', defaultFlex: 2, header: 'Start Time 1', minWidth: 150, editable: false },
        { name: 'end_time', defaultFlex: 2, header: 'End Time 1', minWidth: 150, editable: false },
        { name: 'start_time2', defaultFlex: 2, header: 'Start Time 2', minWidth: 150, editable: false },
        { name: 'end_time2', defaultFlex: 2, header: 'End Time 2', minWidth: 150, editable: false },
        { name: 'start_time3', defaultFlex: 2, header: 'Start Time 3', minWidth: 150, editable: false },
        { name: 'end_time3', defaultFlex: 2, header: 'End Time 3', minWidth: 150, editable: false },
        { name: 'no_of_hours', defaultFlex: 2, header: 'Number of Hours', minWidth: 150, editable: false },
        { name: 'remarks', defaultFlex: 2, header: 'Remarks', minWidth: 150 },
        {
            name: 'sl', defaultFlex: 2, header: 'Actions', minWidth: 150, editable: false,
            render: ({ value }) =>
                <button className="btn btn-sharp" style={{ color: "red" }} onClick={() => showDeleteForm(value)}><i class="fas fa-trash-alt"></i></button>
        },
    ];

    const columns2 = [
        { name: 'generator_type', header: 'Generator Type', minWidth: 150 },
        { name: 'vendor_name', header: 'Vendor Name', minWidth: 150 },
        { name: 'shoot_date', defaultFlex: 2, header: 'Shoot Date', minWidth: 150 },
        { name: 'start_time', defaultFlex: 2, header: 'Start Time 1', minWidth: 150 },
        { name: 'end_time', defaultFlex: 2, header: 'End Time 1', minWidth: 150 },
        { name: 'start_time2', defaultFlex: 2, header: 'Start Time 2', minWidth: 150 },
        { name: 'end_time2', defaultFlex: 2, header: 'End Time 2', minWidth: 150 },
        { name: 'start_time3', defaultFlex: 2, header: 'Start Time 3', minWidth: 150 },
        { name: 'end_time3', defaultFlex: 2, header: 'End Time 3', minWidth: 150 },
        { name: 'no_of_hours', defaultFlex: 2, header: 'Number of Hours', minWidth: 150 },
        { name: 'remarks', defaultFlex: 2, header: 'Remarks', minWidth: 150 },
    ]

    const updateCustomSl = (logs, date) => {
        let temp = 0
        logs.map((log) => {
            if (log.shoot_date == date && log.num_row > temp) {
                console.log(log.num_row)
                temp = parseInt(log.num_row)

            }
        })
        setCustomSl(temp)
    }

    const exportCSV = () => {
        const columns = gridRef.current.visibleColumns;

        const header = columns.map((c) => c.name).join(',');
        const rows = gridRef.current.data.map((data) => columns.map((c) => data[c.id]).join(','));

        const contents = [header].concat(rows).join('\n');
        const blob = new Blob([contents], { type: 'text/csv;charset=utf-8;' });

        downloadBlob(blob);
    };

    const downloadBlob = (blob, fileName = 'grid-data.csv') => {
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.position = 'absolute';
        link.style.visibility = 'hidden';

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    };

    useEffect(() => {
        fetchLogsData()
    }, [])

    const fetchLogsData = async () => {
        setIsLoading(true);
        try {
            const data = await AxiosPost('fetch_generator_logs.php')
            if (data.success) {
                setGeneratorLogs(data.logs)
                updateCustomSl(data.logs, moment().format("YYYY-MM-DD"))
            }
            else pushNotify("error", "Error", data.error)
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const showDeleteForm = (index) => {
        setDeleteModal({ show: true, id: index });
    }

    const deleteItem = async () => {
        setIsLoading(true);
        try {
            const data = await AxiosPost('delete_generator_log.php', { sl: deleteModal.id })
            console.log(data);
            if (data.success) pushNotify('success', 'Success', 'Item Deleted Successfully');
            else pushNotify('error', 'Error', data.error);
            setDeleteModal({ show: false, id: null });
            await fetchLogsData();
            console.log(data);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const cancelDelete = () => {
        setDeleteModal({ show: false, id: null });
    }

    const onChangeHandler = (e, index) => {
        let old = [...formData]
        old[index] = { ...old[index], [e.target.name]: e.target.value }
        setFormData(old)
    }

    const addGeneratorLog = async (e) => {
        e.preventDefault()
        try {
            const data = await AxiosPost('add_generator_log.php', formData)
            console.log(data);
            if (data.success) {
                setFormData([initialFormData])
                await fetchLogsData()
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const calcHours = (index) => {
        var duration = 0;
        if (formData[index].start_time != '' && formData[index].end_time != '') {
            let end_time = moment(formData[index].end_time, "hh:mm:ss")
            let start_time = moment(formData[index].start_time, "hh:mm:ss")
            duration += moment.duration(end_time.diff(start_time)).minutes();
        }
        if (formData[index].start_time2 != '' && formData[index].end_time2 != '') {
            let end_time = moment(formData[index].end_time2, "hh:mm:ss")
            let start_time = moment(formData[index].start_time2, "hh:mm:ss")
            duration += moment.duration(end_time.diff(start_time)).minutes();
        }
        if (formData[index].start_time3 != '' && formData[index].end_time3 != '') {
            let end_time = moment(formData[index].end_time3, "hh:mm:ss")
            let start_time = moment(formData[index].start_time3, "hh:mm:ss")
            duration += moment.duration(end_time.diff(start_time)).minutes();
        }
        let old = [...formData]
        old[index].no_of_hours = duration / 60
        setFormData(old)
        console.log(duration)
    }

    const removeRow = (i) => {
        let old = []
        formData.map((data, index) => index == i ? null : old.push(data))
        setFormData(old)
    }

    const datechangehandler = (e) => {
        let old = [...formData]
        old.map((data, index) => {
            old[index].shoot_date = e.target.value
        })
        setFormData(old)
    }

    const fetchGeneratorOptions = async () => {
        try {
            const data = await AxiosPost('fetch_generator_options.php')
            console.log(data);
            if (data.success) {
                setGeneratorOptions(data.options)
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchGeneratorOptions()
    }, [])

    const onEditComplete = async (e) => {
        try {
            setIsLoading(true)
            let formData = { ...e.data, [e.columnId]: e.value }
            const data = await AxiosPost('update_generator_logs.php', formData)
            if (data.success) {
                await fetchLogsData()
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const handleUpload = (e) => {
        console.log("working")
        e.preventDefault()
        var files = e.target.files, f = files[0];
        const reader = new FileReader();
        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: 'binary' });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws, { header: ["sl", "shoot_date", "vendor_name","start_time", "end_time","start_time2", "end_time2",
            "start_time3", "end_time3", "no_of_hours", "generator_type","remarks","petrol-diesel","price"], blankrows: false, defval: '' });
            data.map((input, index) => {
                input.shoot_date = moment(input.shoot_date, "DD-MM-YYYY").format("YYYY-MM-DD")
            })
            data.shift()
            data.shift()
            console.log(data)
            setUploadData(data)
        };
        reader.readAsBinaryString(f);
    }

    const uploadExcelData = async () => {
        setIsLoading(true)
        try {
            const data = await AxiosPost('add_generator_log_excel.php', uploadData)
            console.log(data);
            if (data.success) {
                await fetchLogsData()
                setUploadData(null)
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    return (
        <div className="col-lg-12 col-md-12 col-sm-12">
            <div>
                {
                    isLoading ? <ScaleLoader cssOverride={{ "display": "flex", "justifyContent": "center", "alignItems": "center" }} /> :
                        <>
                            <div>
                                <input className="form-control mb-2 mr-2" style={{ "width": "fit-content", display: "inline" }} type="file" onChange={handleUpload} id="demo" accept=".xls,.xlsx"></input>
                                <Button style={{ "margin-left": "10px" }} onClick={uploadExcelData}>
                                    Upload
                                </Button>
                                {uploadData == null ? null :
                                    <ReactDataGrid
                                        idProperty="id"
                                        style={gridStyle}
                                        columns={columns2}
                                        pagination="local"
                                        dataSource={uploadData}
                                        defaultLimit={25}
                                        handle={setGridRef}
                                        loading={isLoading}
                                    />
                                }
                            </div>
                            <form className='custom-form-wrapper mb-2' onSubmit={(e) => addGeneratorLog(e)}>
                                <div className="custom-form-inner">
                                    <div className='custom-form-cell'>
                                        <div className='custom-form-label'>
                                            Shoot Date <span className="text-danger">*</span>
                                        </div>
                                        <div className='custom-form-input'>
                                            <input type="date" value={formData[0].shoot_date} name="shoot_date" onChange={(e) => { datechangehandler(e); updateCustomSl(generatorLogs, e.target.value) }} required />
                                        </div>
                                    </div>
                                </div>
                                {formData.map((data, index) => (
                                    <div className='custom-form-inner'>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Sl
                                                <button className="btn btn-primary tp-btn sharp custom-add-button" onClick={(e) => { e.preventDefault(); setFormData([...formData, initialFormData]) }} ><i className="fas fa-plus"></i></button>
                                                {index == 0 ? null : <button className="btn btn-primary tp-btn sharp custom-add-button" onClick={(e) => { e.preventDefault(); removeRow(index) }} ><i className="fas fa-minus"></i></button>}
                                            </div>
                                            <div className='custom-form-input'>
                                                <div className="form-control">{customsl + index + 1}</div>
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Generator Type <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <CreatableSelect
                                                    onChange={(e) => { let old = [...formData]; old[index] = { ...old[index], "generator_type": e }; setFormData(old) }}
                                                    options={generatorOptions}
                                                    value={formData[index].generator_type}
                                                    isDisabled={isLoading2}
                                                    isLoading={isLoading2}
                                                    onCreateOption={(e) => { let temp = [...formData]; temp[index].generator_type = { value: e, label: e }; setFormData(temp) }}
                                                />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Vendor Name <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="text" value={formData[index].vendor_name} name="vendor_name" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Start Time 1
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="datetime-local" value={formData[index].start_time} name="start_time"
                                                    onChange={(e) => {
                                                        let old = [...formData]
                                                        if (formData[index].end_time != '') {
                                                            let end_time = moment(formData[index].end_time, "YYYY-MM-DD HH:mm")
                                                            let start_time = moment(e.target.value, "YYYY-MM-DD HH:mm")
                                                            if (formData[index].start_time != '') {
                                                                let prev_start_time = moment(formData[index].start_time, "YYYY-MM-DD HH:mm")
                                                                old[index].no_of_hours -= (moment.duration(end_time.diff(prev_start_time)).days() * 24 + moment.duration(end_time.diff(prev_start_time)).hours() + moment.duration(end_time.diff(prev_start_time)).minutes() / 60)
                                                            }
                                                            old[index].no_of_hours += (moment.duration(end_time.diff(start_time)).days() * 24 + moment.duration(end_time.diff(start_time)).hours() + moment.duration(end_time.diff(start_time)).minutes() / 60)
                                                        }
                                                        old[index] = { ...old[index], [e.target.name]: e.target.value }
                                                        setFormData(old)
                                                    }} />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                End Time 1
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="datetime-local" value={formData[index].end_time} name="end_time"
                                                    onChange={(e) => {
                                                        let old = [...formData]
                                                        if (formData[index].start_time != '') {
                                                            let end_time = moment(e.target.value, "YYYY-MM-DD HH:mm")
                                                            let start_time = moment(formData[index].start_time, "YYYY-MM-DD HH:mm")
                                                            if (formData[index].end_time != '') {
                                                                let prev_end_time = moment(formData[index].end_time, "YYYY-MM-DD HH:mm")
                                                                old[index].no_of_hours -= (moment.duration(prev_end_time.diff(start_time)).days() * 24 + moment.duration(prev_end_time.diff(start_time)).hours() + moment.duration(prev_end_time.diff(start_time)).minutes() / 60)
                                                            }
                                                            old[index].no_of_hours += (moment.duration(end_time.diff(start_time)).days() * 24 + moment.duration(end_time.diff(start_time)).hours() + moment.duration(end_time.diff(start_time)).minutes() / 60)
                                                        }
                                                        old[index] = { ...old[index], [e.target.name]: e.target.value }
                                                        setFormData(old)
                                                    }} />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Start Time 2
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="datetime-local" value={formData[index].start_time2} name="start_time2"
                                                    onChange={(e) => {
                                                        let old = [...formData]
                                                        if (formData[index].end_time2 != '') {
                                                            let end_time = moment(formData[index].end_time2, "YYYY-MM-DD HH:mm")
                                                            let start_time = moment(e.target.value, "YYYY-MM-DD HH:mm")
                                                            if (formData[index].start_time2 != '') {
                                                                let prev_start_time = moment(formData[index].start_time2, "YYYY-MM-DD HH:mm")
                                                                old[index].no_of_hours -= (moment.duration(end_time.diff(prev_start_time)).days() * 24 + moment.duration(end_time.diff(prev_start_time)).hours() + moment.duration(end_time.diff(prev_start_time)).minutes() / 60)
                                                            }
                                                            old[index].no_of_hours += (moment.duration(end_time.diff(start_time)).days() * 24 + moment.duration(end_time.diff(start_time)).hours() + moment.duration(end_time.diff(start_time)).minutes() / 60)
                                                        }
                                                        old[index] = { ...old[index], [e.target.name]: e.target.value }
                                                        setFormData(old)
                                                    }} />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                End Time 2
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="datetime-local" value={formData[index].end_time2} name="end_time2"
                                                    onChange={(e) => {
                                                        let old = [...formData]
                                                        if (formData[index].start_time2 != '') {
                                                            let end_time = moment(e.target.value, "YYYY-MM-DD HH:mm")
                                                            let start_time = moment(formData[index].start_time2, "YYYY-MM-DD HH:mm")
                                                            if (formData[index].end_time2 != '') {
                                                                let prev_end_time = moment(formData[index].end_time2, "YYYY-MM-DD HH:mm")
                                                                old[index].no_of_hours -= (moment.duration(prev_end_time.diff(start_time)).days() * 24 + moment.duration(prev_end_time.diff(start_time)).hours() + moment.duration(prev_end_time.diff(start_time)).minutes() / 60)
                                                            }
                                                            old[index].no_of_hours += (moment.duration(end_time.diff(start_time)).days() * 24 + moment.duration(end_time.diff(start_time)).hours() + moment.duration(end_time.diff(start_time)).minutes() / 60)
                                                        }
                                                        old[index] = { ...old[index], [e.target.name]: e.target.value }
                                                        setFormData(old)
                                                    }} />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Start Time 3
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="datetime-local" value={formData[index].start_time3} name="start_time3"
                                                    onChange={(e) => {
                                                        let old = [...formData]
                                                        if (formData[index].end_time3 != '') {
                                                            let end_time = moment(formData[index].end_time3, "YYYY-MM-DD HH:mm")
                                                            let start_time = moment(e.target.value, "YYYY-MM-DD HH:mm")
                                                            if (formData[index].start_time3 != '') {
                                                                let prev_start_time = moment(formData[index].start_time3, "YYYY-MM-DD HH:mm")
                                                                old[index].no_of_hours -= (moment.duration(end_time.diff(prev_start_time)).days() * 24 + moment.duration(end_time.diff(prev_start_time)).hours() + moment.duration(end_time.diff(prev_start_time)).minutes() / 60)
                                                            }
                                                            old[index].no_of_hours += (moment.duration(end_time.diff(start_time)).days() * 24 + moment.duration(end_time.diff(start_time)).hours() + moment.duration(end_time.diff(start_time)).minutes() / 60)
                                                        }
                                                        old[index] = { ...old[index], [e.target.name]: e.target.value }
                                                        setFormData(old)
                                                    }} />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                End Time 3
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="datetime-local" value={formData[index].end_time3} name="end_time3"
                                                    onChange={(e) => {
                                                        let old = [...formData]
                                                        if (formData[index].start_time3 != '') {
                                                            let end_time = moment(e.target.value, "YYYY-MM-DD HH:mm")
                                                            let start_time = moment(formData[index].start_time3, "YYYY-MM-DD HH:mm")
                                                            if (formData[index].end_time3 != '') {
                                                                let prev_end_time = moment(formData[index].end_time3, "YYYY-MM-DD HH:mm")
                                                                old[index].no_of_hours -= (moment.duration(prev_end_time.diff(start_time)).days() * 24 + moment.duration(prev_end_time.diff(start_time)).hours() + moment.duration(prev_end_time.diff(start_time)).minutes() / 60)
                                                            }
                                                            old[index].no_of_hours += (moment.duration(end_time.diff(start_time)).days() * 24 + moment.duration(end_time.diff(start_time)).hours() + moment.duration(end_time.diff(start_time)).minutes() / 60)
                                                        }
                                                        old[index] = { ...old[index], [e.target.name]: e.target.value }
                                                        setFormData(old)
                                                    }} />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Number of Hours
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].no_of_hours} name="no_of_hours" onChange={(e) => onChangeHandler(e, index)} />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Remarks
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="text" value={formData[index].remarks} name="remarks" onChange={(e) => onChangeHandler(e, index)} />
                                            </div>
                                        </div>
                                    </div>))}
                                <Button className="mt-2 mb-2">
                                    Add Generator Log
                                </Button>
                            </form>
                        </>
                }

            </div>

            <>
                <Button onClick={fetchLogsData}>
                    Sync Data
                </Button>
                <Button style={{ marginLeft: 10 }} onClick={exportCSV}>
                    Export CSV
                </Button>
                <ReactDataGrid
                    idProperty="id"
                    style={gridStyle}
                    columns={columns}
                    pagination="local"
                    dataSource={generatorLogs}
                    defaultLimit={25}
                    defaultFilterValue={filterValue}
                    handle={setGridRef}
                    loading={isLoading}
                    editable={true}
                    onEditComplete={onEditComplete}
                />
            </>
            <Modal className="fade" show={deleteModal.show} centered>
                <Modal.Header>
                    <Modal.Title>Delete Log?</Modal.Title>
                    <button
                        onClick={cancelDelete}
                        className="btn-close"
                    >
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4>Are you sure you want to delete the Log?</h4>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        onClick={deleteItem}
                        className="btn btn-danger"
                    >
                        Delete
                    </button>
                    <button className="btn btn-primary" onClick={cancelDelete}>Cancel</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
export default GeneratorLogsTable;